import React from 'react'

import { Form } from 'react-form'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

// wrappers for prime react form fields
import FieldInputTextarea from '../common/FieldInputTextarea'

const ChangesRequiredDialogFooter = ({ formApi, closeChangesRequired }) => {
  return (
    <Toolbar>
      <div className="p-toolbar-group-left">
        <Button label="Request Changes" icon="pi pi-check" onClick={formApi.submitForm} />
      </div>
    </Toolbar>
  )
}

const ChangesRequiredDialog = ({ changesRequired, changesRequiredFormSubmitted, isShowingChangesRequiredDialog, closeChangesRequired }) => {
  /* 
     values sets the form state. I'm binding to the props which is linked to redux so we can update the store and the form will be reflected
     this is useful when needed to clear the form or populating the form from another component
     onSubmit is called when the form has been submitted and has passed validation
     formApi properties can be found at https://react-form.js.org/#/
  */
  let validationRules = changesRequired.ValidationRules ? changesRequired.ValidationRules.$values : []
  return (
    <Form values={changesRequired} onSubmit={changesRequiredFormSubmitted}>
      {formApi => {
        let footer = <ChangesRequiredDialogFooter formApi={formApi} closeChangesRequired={closeChangesRequired}></ChangesRequiredDialogFooter>
        return (
          <Dialog visible={isShowingChangesRequiredDialog} header="Required changes to the application" modal={true}
            footer={footer} onHide={closeChangesRequired}>
            <div>
              <FieldInputTextarea rows={3} field={"ChangesRequired"} label={"Required Changes"} validationRules={validationRules} />
            </div>
          </Dialog>
        )
      }
      }
    </Form>
  )
}

export default ChangesRequiredDialog


// WEBPACK FOOTER //
// ./src/components/lobbyist/changes-required-dialog.js